import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Heart, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { getVoterId } from "@/lib/voter";

export function CardActions({ cardId, heading, testId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  const today = new Date().toISOString().slice(0, 10);
  const fullId = `${cardId}:${today}`;

  useEffect(() => {
    const vid = getVoterId();
    api.get("/card/like", { params: { card_id: fullId, voter_id: vid } })
      .then(({ data }) => { setLikes(data.likes); setLiked(data.liked); })
      .catch(() => {});
  }, [fullId]);

  const toggleLike = async () => {
    const vid = getVoterId();
    const wasLiked = liked;
    setLikes((n) => n + (wasLiked ? -1 : 1));
    setLiked(!wasLiked);
    try {
      const { data } = await api.post("/card/like", { card_id: fullId, voter_id: vid });
      setLikes(data.likes);
      setLiked(data.liked);
    } catch {
      setLikes((n) => n + (wasLiked ? 1 : -1));
      setLiked(wasLiked);
    }
  };

  const discuss = () => {
    if (heading) localStorage.setItem("coccon_pending_prompt", t("atelier.cardPrompt", { heading }));
    navigate("/atelier");
  };

  return (
    <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
      <button
        onClick={discuss}
        data-testid={`${testId}-discuss`}
        className="btn-frost-orange inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold"
      >
        <MessageCircle size={15} strokeWidth={2} /> {t("atelier.cardDiscuss")}
      </button>
      <button
        onClick={toggleLike}
        data-testid={`${testId}-like`}
        aria-label={t("atelier.cardLike")}
        className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm border transition-colors ${
          liked
            ? "border-primary/50 text-primary bg-primary/10"
            : "border-white/10 text-foreground/50 hover:text-primary hover:border-primary/30"
        }`}
      >
        <Heart size={15} className={liked ? "fill-primary" : ""} strokeWidth={2} />
        <span data-testid={`${testId}-like-count`}>{likes}</span>
      </button>
    </div>
  );
}
